import { Box } from "@mui/material";
import React from "react";

import { Modal } from "new-components/modals/Modal";
import { Typography } from "new-components/typography/Typography";

type ResetDemoDetectorModalProps = {
  open: boolean;
  onClose: VoidFunction;
  onConfirmation: VoidFunction;
};

export function ResetDemoDetectorModal({ open, onClose, onConfirmation }: ResetDemoDetectorModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      onConfirmation={onConfirmation}
      title="Reset Demo Detector"
      confirmationButtonTitle="Continue"
      onCancel={onClose}
      size="small"
      body={
        <Box width={400}>
          <Typography className="font-bold" align="center">
            Resetting will remove all image queries and answers from the demo detector.
          </Typography>
          <Typography className="font-bold" align="center">
            This is a permanent action and cannot be undone.
          </Typography>
        </Box>
      }
    />
  );
}
